export function download(data, fileName) {
  if (!data) {
    return
  }
  const url = window.URL.createObjectURL(new Blob([data]))
  const link = document.createElement('a')
  link.style.display = 'none'
  link.href = url
  link.setAttribute('download', fileName)

  document.body.appendChild(link)
  link.click()
}

export function downloadFile(response, type) {
  if (response.data) {
    // download(response.data, '加油记录.xlsx')
    const blob = new Blob([response.data], {type: type})
    const fileName = window.decodeURI(response.headers['content-disposition'].split('=')[1])
    // 非IE下载
    if ('download' in document.createElement('a')) {
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob) // 创建下载的链接
      link.download = fileName // 下载后文件名
      link.style.display = 'none'
      document.body.appendChild(link)
      link.click() // 点击下载
      window.URL.revokeObjectURL(link.href) // 释放掉blob对象
      document.body.removeChild(link) // 下载完成移除元素
    } else {
      // IE10+下载
      window.navigator.msSaveBlob(blob, fileName)
    }
  }
}

export function getExcelSuffix(response) {
  const contentType = response.headers['content-type']
  if (contentType === 'application/vnd.ms-excel') {
    return '.xls'
  } else if (contentType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
    return '.xlsx'
  }
  return ''
}
